import { ImageViewer, type ImageSource } from '@powerportalspro/react-fluent';

const source: ImageSource = { kind: 'url', value: 'https://placehold.co/600x400.png' };

export function ImageViewerFramedSample() {
  return <ImageViewer source={source} fileName="placeholder.png" framed downloadable />;
}
